<app-header></app-header>

<div class="container-xxl">
    <section class="banner d-flex justify-content-center align-items-center text-center">
        <div class="content">
          <div class="title">
            <span>تعديل الحساب</span>
          </div>
        
          <div class="links">
            <a class="text-decoration-none" routerLink="/home"> الرئيسية </a>
            <span>/ تعديل الحساب </span>
          </div>
        </div>
      </section>
    
    <main>
        <div class="container">
            <h2 class="mt-5">تعديل الحساب</h2>
            <form [formGroup]="registerForm">
                <div class="form-group">
                    <label>الاسم</label>
                    <input formControlName="userName" [class.is-invalid]="userName.invalid && userName.touched" type="text"
                        class="form-control" />
                    <div *ngIf=" userName.errors && (userName.invalid && userName.touched)">
                        <small class="text-danger" *ngIf="userName.errors?.required">
                            الاسم مطلوب
                        </small>
                        <small class="text-danger" *ngIf="userName.errors.minlength">
                            لا يجب ان يقل الاسم عن 5 حروف
                        </small>
                        <small *ngIf="userName.errors?.forbiddenName">
                            {{userName.errors?.forbiddenName.value}} غير متاح
                        </small>
                    </div>
                </div>
        
                <div class="form-group">
                    <label>الاسم الأول</label>
                    <input formControlName="firstName" [class.is-invalid]="firstName.invalid && firstName.touched" type="text"
                        class="form-control" />
                    <div *ngIf=" firstName.errors && (firstName.invalid && firstName.touched)">
                        <small class="text-danger" *ngIf="firstName.errors?.required">
                            الاسم الأول مطلوب
                        </small>
                        <small class="text-danger" *ngIf="firstName.errors.minlength">
                            لا يجب ان يقل الاسم عن 5 حروف
                        </small>
                    </div>
                </div>
        
                <div class="form-group">
                    <label>اسم العائلة</label>
                    <input formControlName="lastName" [class.is-invalid]="lastName.invalid && lastName.touched" type="text"
                        class="form-control" />
                    <div *ngIf=" lastName.errors && (lastName.invalid && lastName.touched)">
                        <small class="text-danger" *ngIf="lastName.errors?.required">
                            اسم العائلة مطلوب
                        </small>
                        <small class="text-danger" *ngIf="lastName.errors.minlength">
                            لا يجب ان يقل الاسم عن 5 حروف
                        </small>
                    </div>
                </div>
        
                <div class="form-group">
                    <label>الرقم السري</label>
                    <input formControlName="password" type="password" class="form-control" />
                    <div *ngIf=" password.errors && (password.invalid && password.touched)">
                        <small class="text-danger" *ngIf="password.errors?.required">
                            الرقم السري مطلوب
                        </small>
                        <small class="text-danger" *ngIf="password.errors.minlength">
                            لا يجب ان يقل الاسم عن 8 حروف
                        </small>
                    </div>
                </div>
        
                <div class="form-group">
                    <label>تأكيد الرقم السري</label>
                    <input [class.is-invalid]="registerForm.errors?.misMatch" formControlName="confirmPassword" type="password"
                        class="form-control" />
                    <small *ngIf="registerForm.errors?.misMatch" class="text-danger">
                       الرقم السري غير مطابق
                    </small>
                </div> 
        
                <div class="form-group">
                    <label>البريد الإلكتروني</label>
                    <input pattern='^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$' type="text"
                         [class.is-invalid]="email.invalid && email.touched"  formControlName="email"  class="form-control">
                    <small class="text-danger" [class.d-none]="email.valid || email.untouched">
                       البريد الإلكتروني غير متاح
                    </small>
                </div>
        
            
                {{user.birthDate|date:"yyyy-MM-dd"}}
                <div class="form-group">
                    <label>تاريخ الميلاد</label>
                    <input formControlName="birthDate" type="date" class="form-control"
                    />
                </div>
        
                
        
                <div class="form-group">
                    <label>النوع:</label>
                    <select  formControlName="gender"  class="form-control">
                        <option value="Male">ذكر</option>
                        <option value="Female">أنثى</option>
                    </select>
                </div>
        
                     
                <div class="form-group">
                    <label>البلد :</label>
                    <select class="form-control" formControlName="country" (change)="countryChanged()"  >
                        <option *ngFor = "let c of countries"  value="{{c._id}}">{{c.name}}</option>
                      </select>
                </div>
                
              
                <div class="form-group">
                    <label>رقم الهاتف</label>
                    <input  type="tel"  formControlName="phone"  class="form-control">
                    <div *ngIf=" phone.errors && (phone.invalid && phone.touched)">
                        <small class="text-danger" *ngIf="phone.errors?.required">
                            رقم الهاتف مطلوب
                        </small>
                        <small class="text-danger" *ngIf="phone.errors.minlength||phone.errors.maxlength">
                            length is 10
                        </small>
                    </div>
                </div>
        
                   
        
        
                <div class="form-group">
                    <div class="progress" *ngIf="existingFile">
                        <div
                          class="progress-bar progress-bar-striped bg-danger"
                          attr.aria-valuenow="{{ progress }}"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [ngStyle]="{ width: progress + '%' }"
                        >
                          {{ progress }}%
                        </div>
                      </div>
                      
                      <label class="btn btn-default">
                        <input type="file" (change)="chooseFile($event)" />
                      </label>
                      <img src="https://khairokom-uploadfiles.azurewebsites.net/files/{{fileName}}" height="200px" width="200px">
                      <button class="upload btn btn-primary" [disabled]="!chosenFiles" (click)="upload()">
                        تحميل الصورة
                      </button>
                      
                      <div class="alert alert-light">{{ msg }}</div>
                </div>
                <button type="submit" class="update btn btn-success" (click)="update()">تعديل</button>
                
            </form>
            <br>
           
        </div>
    </main>
</div>

<app-footer></app-footer>